import CoinRebase from './index';

export default {
    path: '/home/coin/rebase',
    component: CoinRebase
}